import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CheckIcon, CopyIcon } from '@radix-ui/react-icons';
import { Button, ButtonProps } from '../button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import React from 'react';

type Props = {
  text: string;
  slots?: {
    button? :ButtonProps
  }
};
function CopyIconButton({ text, slots }: Props) {
  const [hasCopied, setHasCopied] = React.useState(false);

  const handleCopy = React.useCallback(() => {
    setHasCopied(true);
    const timer = setTimeout(() => {
      setHasCopied(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <CopyToClipboard text={text} onCopy={handleCopy}>
              <Button variant={'ghost'} size="icon" className="h-6 w-6" {...slots?.button}>
                {hasCopied ? (
                  <CheckIcon className="h-3 w-3" />
                ) : (
                  <CopyIcon className="h-3 w-3" />
                )}
              </Button>
            </CopyToClipboard>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Copy to clipboard</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default CopyIconButton;
